export const minLengthMsg = "zod.min-length";
export const requiredMsg = "common:zod.required";
export const countryMsg = "common:zod.country";
export const dateMsg = "common:zod.date";
export const priceMsg = "common:zod.price";
export const UTR_ErrorMsg = "common:zod.UTR";
export const ATP_WTA_ITF_ErrorMsg = "common:zod.ATP_WTA_ITF";
export const emailMsg = "common:zod.email";
export const descriptionMsg = "common:zod.description";
